import { Type } from "@angular/core";
import { InterviewsV2Service } from "src/app/services/interviews-v2.service";
import { MeUser } from "src/app/services/models/me-user";
import { OpenInterviewDetailCommand } from "src/app/shared/commands/open-interview-detail-command";
import { CreateRecoveryPlanCommand } from "src/app/shared/commands/create-recovery-plan-command";
import { ActionCol } from "src/app/shared/table-col-configs/action-col";
import { ActionButtonsNoTextComponent } from "src/app/shared/table-components/action-buttons-no-text/action-buttons-no-text.component";
import { DetailButtonComponent } from "src/app/shared/table-components/detail-button/detail-button.component";
import { IQuestion } from "src/app/interface/filters";
import { InterviewsService } from "src/app/services/interviews.service";
import { TextCol } from "../../../../records/models/columns/text-col";

export const INTERVIEW_SUMMARY_COLUMNS_PLATFORM = (
  user: MeUser,
  service: InterviewsService | InterviewsV2Service,
  question: IQuestion
) => [
  new ActionCol<any, Type<DetailButtonComponent<any>>, InterviewsService | InterviewsV2Service>(
    "surveyRequestId",
    true,
    "Survey Request Id",
    [new OpenInterviewDetailCommand()],
    DetailButtonComponent,
    true,
    undefined,
    true
  ),
  new TextCol("interviewdate"),
  new TextCol("agentName"),
  new TextCol("brand", false, undefined, undefined, true, false),
  new TextCol("customerName", true, undefined, undefined, undefined, undefined, undefined, true),
  new TextCol("anonimityRelease"),
  new TextCol("dealer", false, undefined, undefined, false, false),
  new TextCol("dealerName", undefined, undefined, undefined, true, undefined, undefined, true),
  new TextCol("market"),
  new TextCol("vin", true),
  new TextCol("dealerGroup"),
  new TextCol("engine", false, undefined, undefined, true, false),
  new TextCol("modelComputed"),
  new TextCol("channel"),
  new TextCol("alertRaised", false, "alertRaised", undefined, true),
  new TextCol("orderCustomerType", undefined, "TCO/Typeutil", undefined, true),
  new TextCol("promotionCode", undefined, "Promo Code - CCB / NRM Subtypes", undefined, true),
  new TextCol("rpDtStatus", undefined, undefined, undefined, true, undefined, undefined, false),
  new ActionCol<any, Type<ActionButtonsNoTextComponent<any>>, InterviewsService | InterviewsV2Service>(
    "rpCreateBtn",
    false,
    "hotAlertTable.rpStatus",
    [new CreateRecoveryPlanCommand<any, InterviewsService | InterviewsV2Service>(service)],
    ActionButtonsNoTextComponent,
    false
  ),
];
